import delegateEvent from '../utilities/delegateEvent.js';

export default function LinkTransition() {
  const doTransition = function (url) {
    // do transition
    document.documentElement.classList.add('w-is-fading');
    const timeout =
      parseFloat(
        window.getComputedStyle(this.fadeOutElement).transitionDuration
      ).toFixed(3) * 1000;

    setTimeout(() => {
      window.location.href = url;
    }, timeout);
  };

  return {
    init: () => {
      this.fadeOutElement = document.querySelector('[data-w-fader="out"]');

      window.onpageshow = (event) => {
        if (event.persisted) {
          document.documentElement.classList.remove('w-is-fading');
        }
      };

      delegateEvent(
        document,
        'click',
        'a[href^="' +
          window.location.protocol +
          '//' +
          window.location.host +
          '"]:not([href="' +
          window.location.href +
          '"]):not([href^="#"]):not([download]):not([target="_blank"]):not([class*="w-js-"])',
        (event, element) => {
          event.preventDefault();

          doTransition(element.href);
        }
      );
    },
  };
}
